// src/pages/admin/LoyaltyPage.jsx
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { useState } from 'react'
import { adminLoyaltyApi } from '../../api/services'
import { Card, CardHeader, CardBody, Button, PageSpinner } from '../../components/common/ui'
import toast from 'react-hot-toast'

export default function AdminLoyaltyPage() {
  const qc = useQueryClient()
  const [adj, setAdj] = useState({ user_id:'', points:'', reason:'' })
  const { data, isLoading } = useQuery({ queryKey: ['admin-loyalty'], queryFn: () => adminLoyaltyApi.index() })
  const adjust = useMutation({ mutationFn: () => adminLoyaltyApi.adjust(adj), onSuccess: () => { toast.success('Points adjusted'); qc.invalidateQueries(['admin-loyalty']); setAdj({ user_id:'', points:'', reason:'' }) }, onError: e => toast.error(e.response?.data?.message || 'Error') })

  if (isLoading) return <PageSpinner />
  const { top_buyers=[], total_issued=0, total_redeemed=0, total_expired=0, active_ledgers=0, config={} } = data?.data?.data || {}

  return (
    <div>
      <h1 className="text-xl font-display font-bold mb-6">Loyalty Programme</h1>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mb-6">
        {[['Points Issued', Number(total_issued).toLocaleString('en-IN')],['Redeemed', Number(total_redeemed).toLocaleString('en-IN')],['Expired', Number(total_expired).toLocaleString('en-IN')],['Active Accounts', active_ledgers]].map(([l,v])=>(
          <div key={l} className="bg-white border border-border rounded-xl p-4"><p className="text-xs text-muted">{l}</p><p className="text-xl font-bold">{v}</p></div>
        ))}
      </div>
      <Card className="mb-6">
        <CardHeader><span className="font-bold text-sm">Manual Adjustment</span></CardHeader>
        <CardBody className="flex gap-3 flex-wrap">
          <input className="input" type="number" placeholder="User ID *" value={adj.user_id} onChange={e => setAdj(a => ({ ...a, user_id: e.target.value }))} />
          <input className="input" type="number" placeholder="Points (neg to deduct) *" value={adj.points} onChange={e => setAdj(a => ({ ...a, points: e.target.value }))} />
          <input className="input flex-1" placeholder="Reason *" value={adj.reason} onChange={e => setAdj(a => ({ ...a, reason: e.target.value }))} />
          <Button loading={adjust.isPending} disabled={!adj.user_id || !adj.points || !adj.reason} onClick={() => adjust.mutate()}>Adjust</Button>
        </CardBody>
      </Card>
      {top_buyers.length > 0 && (
        <Card>
          <CardHeader><span className="font-bold text-sm">Top Buyers by Points</span></CardHeader>
          <CardBody className="p-0">
            {top_buyers.slice(0,10).map((b, i) => (
              <div key={b.user_id} className="flex items-center justify-between px-5 py-3 border-b border-border last:border-b-0 text-sm">
                <span className="font-medium">#{i+1} {b.name}</span>
                <span className="font-bold text-pink">{Number(b.balance).toLocaleString('en-IN')} pts</span>
              </div>
            ))}
          </CardBody>
        </Card>
      )}
    </div>
  )
}
